import { maxNameLength } from "src/common/rxName";
import { zSidLabel } from "src/types";
import z from "zod";

import { zSysDataHistory } from "../sysData/ZSysData";
import { zWorkflowStep } from "./ZWorkflowStep";

export const zWorkflowDestination = z.enum(["CREATE_RECORD", "UPDATE_RECORD"]);
export type ZWorkflowDestination = z.infer<typeof zWorkflowDestination>;

export const workflowDestinations: Record<ZWorkflowDestination, string> = {
  CREATE_RECORD: "Создание записей",
  UPDATE_RECORD: "Редактирование записей",
};
export const defaultWorkflowDestination: ZWorkflowDestination = "UPDATE_RECORD";

// Общую часть пришлось выделить для конвертирования в сохраняемый формат
export const zWorkflowCommon = z.object({
  name: z.string().max(maxNameLength).optional(),
  displayName: z.string().max(maxNameLength).nullish(),
  description: z.string().nullish(),
  catalog: zSidLabel.nullish(),
  roles: zSidLabel.array(),
  owner: zSidLabel.nullish(),
  steps: zWorkflowStep.array().nullish(),
  destination: zWorkflowDestination.nullish(),
  version: z.number().optional(), // В описании этого поля нет
});
export type ZWorkflowCommon = z.infer<typeof zWorkflowCommon>;

export const zWorkflow = z.object({
  id: z.string(),
  displayId: z.number(),
  ...zWorkflowCommon.shape,
  ...zSysDataHistory.shape,
});

export type ZWorkflow = z.infer<typeof zWorkflow>;

export type WorkflowsFilter = {};
